import styled, { css } from 'styled-components'

export default styled.button`
    background-color: #ccc;
    border: 0;
    cursor: pointer;
    width: 100%;
    color: #fff;

    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #FFFFFF;
    border-radius: 24px;
    font-size: 1.2rem;
    font-weight: bold;
    padding: 16px 34px;

    ${props => props.inline && css`
        width: auto;
    `}

    ${props => props.primary && css`
        background-color: #F50;
    `}
`


// WEBPACK FOOTER //
// ./src/SPRINTA/v3/Button/index.js